export enum CargoPalletDetailsActionTypes {
  SET_TOTAL_PALLET_COUNT = "SET_TOTAL_PALLET_COUNT",
  SET_TOTAL_PALLET_WEIGHT = "SET_TOTAL_PALLET_WEIGHT",
  ADD_NEW_PALLET_LINE_ITEM = "ADD_NEW_PALLET_LINE_ITEM",
  REMOVE_PALLET_LINE_ITEM = "REMOVE_PALLET_LINE_ITEM",
  UPDATE_PALLET_LINE_ITEM = "UPDATE_PALLET_LINE_ITEM",
}
